/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */

import * as React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import styled from "styled-components";

import Modal from "../../../reusable/reactModal";
import { FeesModalPropTypes } from "../lib/types";
import {
  StyledLinkSpan,
  StyledModalBody,
  StyledModalContents,
  StyledModalText,
  StyledTable,
  StyledTableData,
  StyledTableHeader,
} from "../lib/styles";
import { redesignTheme } from "../../../theme/theme";

const StyledDescription = styled(StyledModalText)`
  margin-bottom: ${redesignTheme.spacing[4.5]};
`;

const StyledTableWrapper = styled.div`
  padding: ${redesignTheme.spacing[4.5]} ${redesignTheme.spacing[6]};
  margin-bottom: ${redesignTheme.spacing[4.5]};
  background: ${redesignTheme.color.gray50};
  border-radius: ${redesignTheme.radius.sm};
`;

const StyledTableDataLeft = styled(StyledTableData)`
  text-align: left;
`;

const FeesModal = ({
  closeModal,
  modal,
}: FeesModalPropTypes): React.ReactElement => {
  return (
    <Modal
      ariaLabel={i18n.translate(
        "admin_pages.settings.billing.fees_modal_aria_label"
      )}
      close={closeModal}
      showDialog={modal === "fees"}
      testId="fees-modal"
      title={i18n.translate("admin_pages.settings.billing.fees_modal_title")}
    >
      <StyledModalBody>
        <StyledModalContents>
          <StyledDescription>
            {i18n.translate(
              "admin_pages.settings.billing.fees_modal_description"
            )}
          </StyledDescription>

          <StyledTableWrapper>
            <StyledTable
              data-testid="fees-table"
              style={{ width: "100%", margin: "0" }}
            >
              <tbody>
                <tr style={{ height: "32px" }}>
                  <StyledTableHeader>
                    {i18n.translate(
                      "admin_pages.settings.billing.pay_as_you_go_plan"
                    )}
                  </StyledTableHeader>
                  <StyledTableDataLeft>
                    {i18n.translate(
                      "admin_pages.settings.billing.convenience_fee",
                      { fee: "8" }
                    )}
                  </StyledTableDataLeft>
                </tr>
                <tr style={{ height: "32px" }}>
                  <StyledTableHeader>
                    {i18n.translate("admin_pages.settings.billing.flex_plan")}
                  </StyledTableHeader>
                  <StyledTableDataLeft>
                    {i18n.translate(
                      "admin_pages.settings.billing.convenience_fee",
                      { fee: "5" }
                    )}
                  </StyledTableDataLeft>
                </tr>
                <tr>
                  <StyledTableHeader>
                    {i18n.translate("admin_pages.settings.billing.fixed_plan")}
                  </StyledTableHeader>
                  <StyledTableDataLeft>
                    {i18n.translate("admin_pages.settings.billing.no_fee")}
                  </StyledTableDataLeft>
                </tr>
              </tbody>
            </StyledTable>
          </StyledTableWrapper>

          <StyledLinkSpan>
            <a
              href="https://help.bonus.ly/en/articles/8871592-how-do-i-change-my-reward-billing-plan"
              target="_blank"
            >
              {i18n.translate("admin_pages.settings.billing.learn_more")}
            </a>{" "}
            {i18n.translate(
              "admin_pages.settings.billing.fees_modal_learn_about_fees"
            )}
          </StyledLinkSpan>
        </StyledModalContents>
      </StyledModalBody>
    </Modal>
  );
};

export default FeesModal;
